import api from './api';
import type { Paginated, WithdrawalRequest } from '../types/api';

export async function listWithdrawals(params?: { status?: string }) {
  const { data } = await api.get<Paginated<WithdrawalRequest> | WithdrawalRequest[]>(
    '/finance/withdrawals/', { params },
  );
  return Array.isArray(data) ? data : data.results;
}

export async function approveWithdrawal(id: number) {
  await api.post(`/finance/withdrawals/${id}/approve/`);
}

export async function rejectWithdrawal(id: number) {
  await api.post(`/finance/withdrawals/${id}/reject/`);
}

export async function markProcessed(id: number) {
  await api.post(`/finance/withdrawals/${id}/mark-processed/`);
}
